import React from "react";
import CustomerList from "../../Customers/CustomerList";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";

interface Props {
  storeId: string;
}

const StoreCustomersTab: React.FC<Props> = ({ storeId }) => {
  const userDetails = useSelector((state: RootState) => state.user.userDetails);

  return (
    <CustomerList companyId={userDetails?.companyId} contextStoreId={storeId} />
  );
};

export default StoreCustomersTab;
